module.exports = __webpack_public_path__ + "img/ink-eraser.5803c6a2.svg";